import NBType, { InferType } from '@netbase/nb-type'
import AlertSchema from './AlertSchema'

const LogInfoSchema = NBType.object().shape('LogInfoSchema', {
  /* @prop */
  alertDTO: AlertSchema.nullable(),
  /* @prop */
  batchUUID: NBType.string(),
  /* @prop */
  dashboardId: NBType.number(),
  /* @prop */
  dashboardName: NBType.string()
  /* END */
})
export default LogInfoSchema
export type LogInfo = InferType<typeof LogInfoSchema>
// RESERVE BELOW
